<template>
    <reports-base
        exportable
        reports-name="promoBillings"
        reports-title="Raport rozliczeniowy"
        component-name="PromoBillings"
        exportable-tooltip="Eksport zawiera maksymalnie 31 dni kalendarzowych"
        :results-phrase="this.$store.getters.getPromoBillingsResultsPhrase"
        @onExport="onExport"
        :report-invalid-condition="
            report => !report.promotions || report.promotions.length === 0
        "
    >
        <div class="text-sm a-infoBar a-infoBar--warning">
            Niniejszy raport jest raportem poglądowym. Wartości w nim
            występujące mogą różnić się od finalnych rozliczeń publikowanych w
            zakładce Rozliczenia.<br/>
            Eksport zawiera maksymalnie 31 dni kalendarzowych
        </div>
        <div class="c-thead">
            <div class="c-td is-1">Promocja</div>
            <div class="c-td is-2">Producent</div>
            <div class="c-td is-3">Data<br />użycia</div>
            <div class="c-td is-4">Data<br />rejestracji</div>
            <div class="c-td is-5">Tydzień<br />rozliczeniowy</div>
            <div class="c-td is-6">Status</div>
            <div class="c-td is-7">Liczba<br />użyć</div>
            <div class="c-td is-8">
                <div
                    v-tooltip="'Prognozowany Zwrot Kosztów'"
                    class="d-flex flex-column align-items-center justify-content-end"
                >
                    <span class="typo-label">
                        Zwrot<br />
                        Kosztów
                    </span>
                    <a-icon
                        class="typo-label icon ml-1"
                        icon="Info"
                        style="width: 16px; height: 16px"
                    />
                </div>
            </div>
        </div>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    components: {
        ReportsBase
    },
    methods: {
        onExport() {
            this.$store.dispatch('fetchPromoBillingReport')
        }
    }
}
</script>
